/**
 * F5-Capture — photos and video. Video is deliberately first.
 * Media upload wiring (S3 presigned URLs) is a later task; this establishes the
 * screen, the shot list, and the flow. Files are held client-side for now.
 */
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

interface CaptureState {
  serviceLine?: string;
  productCode?: string;
}

const SHOTS = [
  'A slow video panning the whole room',
  'The wall with the plumbing',
  'The floor, especially near the tub or toilet',
  'Anything already cracked, stained or soft',
];

export function Capture(): JSX.Element {
  const navigate = useNavigate();
  const location = useLocation();
  const state = (location.state as CaptureState) ?? {};
  const [count, setCount] = useState(0);

  return (
    <div className="flow flow--single">
      <div className="stage-card">
        <h1>Show us the room.</h1>
        <p className="stage-card__lede">
          Start with a short video &mdash; it tells us more than any single photo. Then a few
          stills. Straight from your phone is perfect.
        </p>

        <label
          className="pb-surface"
          style={{ display: 'flex', flexDirection: 'column', gap: 'var(--pb-2)', cursor: 'pointer', textAlign: 'center' }}
        >
          <span className="pb-option__label">Record or upload a video</span>
          <span className="pb-option__sub">A slow pan around the room, 20&ndash;30 seconds</span>
          <input
            type="file"
            accept="video/*"
            capture="environment"
            style={{ display: 'none' }}
            onChange={(e) => setCount((c) => c + (e.target.files?.length ?? 0))}
          />
        </label>

        <div className="pb-surface" style={{ marginTop: 'var(--pb-3)' }}>
          <div className="pb-option__label" style={{ marginBottom: 'var(--pb-2)' }}>
            Then these shots
          </div>
          <ul style={{ margin: 0, paddingLeft: 'var(--pb-5)', color: 'var(--pb-ink-soft)', fontSize: 'var(--pb-size-small)' }}>
            {SHOTS.map((s) => (
              <li key={s}>{s}</li>
            ))}
          </ul>
          <label
            className="pb-btn pb-btn--ghost"
            style={{ marginTop: 'var(--pb-4)', cursor: 'pointer' }}
          >
            Add photos
            <input
              type="file"
              accept="image/*"
              multiple
              capture="environment"
              style={{ display: 'none' }}
              onChange={(e) => setCount((c) => c + (e.target.files?.length ?? 0))}
            />
          </label>
        </div>

        <div className="q-actions">
          <button
            type="button"
            className="pb-btn pb-btn--next pb-btn--lg"
            onClick={() => navigate('/submitted', { state })}
          >
            {count > 0 ? `Send ${count} file${count === 1 ? '' : 's'}` : 'Continue'}
          </button>
        </div>
      </div>
    </div>
  );
}
